import type * as userApi from '@/services/common/user';
export default function access(initialState: { currentUser?: userApi.GetDetailRes } | undefined) {
  const { currentUser } = initialState ?? {};
  return {
    canAdmin: currentUser?.username === 'admin',
  };
}
